import { configureStore } from '@reduxjs/toolkit';
import searchReducer from "./features/searchSlice";
import productsReducer from './features/productsSlice';
import cartReducer from './features/cartSlice';
import authReducer from './features/authSlice';
import addressesReducer from './features/addressesSlice';
import favoritesReducer from './features/favoritesSlice';
import ordersReducer from './features/ordersSlice';
import { analyticsListener } from './analyticsListener';

export const store = configureStore({
  reducer: {
    search: searchReducer,
    products: productsReducer,
    cart: cartReducer,
    auth: authReducer,
    addresses: addressesReducer,
    favorites: favoritesReducer,
    orders: ordersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(analyticsListener.middleware),
});
